import React from 'react';
import { HomeSectionProps } from './HomeSectionProps';

const socialLinks = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/playballfantasy',
    icon: 'bi-instagram',
    description: '최신 소식과 이벤트를 확인하세요.',
    className: 'instagram-link'
  },
  {
    name: '네이버 카페',
    href: 'https://cafe.naver.com/playballfantasy',
    image: '/naver-cafe.png',
    description: '다른 유저들과 소통하고 정보를 공유하세요.',
    className: 'naver-link'
  }
];

const SNSLinks: React.FC<HomeSectionProps> = ({ className }) => {
  return (
    <section id="social" className={`py-5 ${className ?? ''}`}>
      <div className="container py-5">
        <div className="text-center mb-5">
          <span className="badge rounded-pill text-bg-primary bg-opacity-75 mb-3">커뮤니티</span>
          <h2 className="fw-bold">플레이볼과 소통하세요</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>
            다양한 채널에서 플레이볼의 최신 소식을 접하고 다른 유저들과 함께하세요.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {socialLinks.map((link) => (
            <div key={link.name} className="col-lg-4 col-md-6">
              <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <div className={`card shadow-sm h-100 text-center border-0 social-card ${link.className}`}>
                  <div className="card-body p-5">
                    {link.image ? (
                      <img src={link.image} alt={link.name} style={{ width: '62px', height: '62px' }} className='mb-2' />
                    ) : (
                      <i className={`bi ${link.icon} display-4 mb-4`}></i>
                    )}
                    <h3 className="h5 fw-semibold">{link.name}</h3>
                    <p className="text-muted small">{link.description}</p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .social-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .social-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
        }
        .social-card.instagram-link i {
          background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
      `}</style>
    </section>
  );
};

export default SNSLinks;
